// extracted by mini-css-extract-plugin
export default {"container":"LoadingIcon_container__dcYxl","image":"LoadingIcon_image__TIWlu","rotate":"LoadingIcon_rotate__nwOh3"};